import { forwardRef, type InputHTMLAttributes, type ReactNode } from 'react';

const Checkbox = forwardRef<HTMLInputElement, InputHTMLAttributes<HTMLInputElement> & { label: ReactNode }>(function Checkbox({ label, ...rest }, ref) {
  return (
    <label className="check">
      <input ref={ref} type="checkbox" {...rest} />
      <span>{label}</span>
    </label>
  );
});
export default Checkbox;
